(function () {
  function initialize(root) {
    root.querySelectorAll('.lawson-hiace__photo-picker').forEach(function (picker) {
      if (picker.dataset.photoGalleryReady) return;
      var main = picker.parentElement.querySelector('.lawson-hiace__access-main');
      if (!main) return;
      picker.dataset.photoGalleryReady = 'true';
      picker.addEventListener('click', function (event) {
        var button = event.target.closest('[data-hiace-photo]');
        if (!button || !picker.contains(button)) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = button.dataset.hiacePhoto;
        main.alt = button.dataset.hiaceAlt;
        if (button.dataset.photoWidth) main.width = Number(button.dataset.photoWidth);
        if (button.dataset.photoHeight) main.height = Number(button.dataset.photoHeight);
        picker.querySelectorAll('button').forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === button));
        });
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
